import React from "react";
import ProductGrid from "../components/ProductGrid";

function ProductosPage() {
  return (
    <div className="productos-page">
      <ProductGrid />
    </div>
  );
}

export default ProductosPage;
